<template>
  <UIPopup
    v-model="modelValue"
    closeable
    hide-buttons
    :max-width="isDesktop ? '768px' : isTablet ? '584px' : ''"
    @close="modelValue = false"
  >
    <template #header>
      <div class="mx-auto mt-24 max-w-[468px] text-black-80">
        <UIBaseTransition>
          <div v-if="submitted">
            <h1 class="text-center text-2xl">{{ $t('support.help.steps.success.title') }}</h1>
          </div>
          <div v-else>
            <h1 class="text-2xl font-bold tablet:text-left">{{ $t('support.help.steps.form.title') }}</h1>
          </div>
        </UIBaseTransition>
      </div>
    </template>
    <template #body>
      <UIBaseTransition>
        <div v-if="submitted" class="mx-auto flex max-w-[361px] flex-col items-center justify-center gap-8">
          <span class="text-lg">{{ $t('support.help.steps.success.message') }}</span>
          <UIIcon name="handshake-filled" size="unset" class="!size-[256px]" />
        </div>
        <div v-else class="mx-auto flex max-w-[468px] flex-col gap-4 tablet:text-left">
          <span class="text-base font-normal !leading-4">
            {{ $t('support.help.steps.form.description') }}
          </span>
          <form ref="parentRef" class="flex w-full flex-col gap-4" @submit.prevent="onSubmit">
            <UIInputText name="name" :placeholder="$t('support.help.steps.form.namePlaceholder')" />
            <UIInputText name="subject" :placeholder="$t('support.help.steps.form.subjectPlaceholder')" />
            <UITextArea
              name="message"
              :placeholder="$t('support.help.steps.form.messagePlaceholder')"
              min-height="100"
              sync-v-model
            />
            <UIButton id="submit" :loading="isPending" type="submit" full-width>
              {{ $t('support.help.steps.form.submit') }}
            </UIButton>
          </form>
        </div>
      </UIBaseTransition>
    </template>
  </UIPopup>
</template>

<script setup lang="ts">
import { useForm } from 'vee-validate'
import { helpSchema } from '@/schemas/support/help'

const modelValue = defineModel<boolean>()

const { isTablet, isDesktop } = useAppBreakpoints()

const { handleSubmit } = useForm<{ name: string; subject: string; message: string }>({
  validationSchema: helpSchema,
})

const { catchErrors } = useErrorHandler()

const { mutateAsync: sendSupportMessage, isPending } = useSendSupportMessage()

const submitted = ref(false)

const onSubmit = handleSubmit((values) => {
  sendSupportMessage(values)
    .then(() => {
      submitted.value = true
    })
    .catch(catchErrors)
})

const [parentRef] = useAutoAnimate()
</script>
